import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/documentation/documentation/node_modules/gatsby-theme-doctornpm/src/components/layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h3>{`Synopsis`}</h3>
    {
      /* AUTOGENERATED USAGE DESCRIPTIONS START */
    }
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/commands/run-script.js */
    }
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`npm run-script <command> [-- <args>]

aliases: run, rum, urn
`}</code></pre>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/commands/run-script.js */
    }
    {
      /* AUTOGENERATED USAGE DESCRIPTIONS END */
    }
    <h3>{`Description`}</h3>
    <p>{`This runs an arbitrary command from a package's `}<inlineCode parentName="p">{`"scripts"`}</inlineCode>{` object.  If no
`}<inlineCode parentName="p">{`"command"`}</inlineCode>{` is provided, it will list the available scripts.`}</p>
    <p><inlineCode parentName="p">{`run[-script]`}</inlineCode>{` is used by the test, start, restart, and stop commands, but
can be called directly, as well. When the scripts in the package are
printed out, they're separated into lifecycle (test, start, restart) and
directly-run scripts.`}</p>
    <p>{`Any positional arguments are passed to the specified script.  Use `}<inlineCode parentName="p">{`--`}</inlineCode>{` to
pass `}<inlineCode parentName="p">{`-`}</inlineCode>{`-prefixed flags and options which would otherwise be parsed by npm.`}</p>
    <p>{`For example:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`npm run test -- --grep="pattern"
`}</code></pre>
    <p>{`The arguments will only be passed to the script specified after `}<inlineCode parentName="p">{`npm run`}</inlineCode>{`
and not to any `}<inlineCode parentName="p">{`pre`}</inlineCode>{` or `}<inlineCode parentName="p">{`post`}</inlineCode>{` script.`}</p>
    <p>{`The `}<inlineCode parentName="p">{`env`}</inlineCode>{` script is a special built-in command that can be used to list
environment variables that will be available to the script at runtime. If an
"env" command is defined in your package, it will take precedence over the
built-in.`}</p>
    <p>{`In addition to the shell's pre-existing `}<inlineCode parentName="p">{`PATH`}</inlineCode>{`, `}<inlineCode parentName="p">{`npm run`}</inlineCode>{` adds
`}<inlineCode parentName="p">{`node_modules/.bin`}</inlineCode>{` to the `}<inlineCode parentName="p">{`PATH`}</inlineCode>{` provided to scripts. Any binaries
provided by locally-installed dependencies can be used without the
`}<inlineCode parentName="p">{`node_modules/.bin`}</inlineCode>{` prefix. For example, if there is a `}<inlineCode parentName="p">{`devDependency`}</inlineCode>{` on
`}<inlineCode parentName="p">{`tap`}</inlineCode>{` in your package, you should write:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`"scripts": {"test": "tap test/*.js"}
`}</code></pre>
    <p>{`instead of`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`"scripts": {"test": "node_modules/.bin/tap test/*.js"}
`}</code></pre>
    <p>{`The actual shell your script is run within is platform dependent. By default,
on Unix-like systems it is the `}<inlineCode parentName="p">{`/bin/sh`}</inlineCode>{` command, on Windows it is
`}<inlineCode parentName="p">{`cmd.exe`}</inlineCode>{`.
The actual shell referred to by `}<inlineCode parentName="p">{`/bin/sh`}</inlineCode>{` also depends on the system.
You can customize the shell with the `}<inlineCode parentName="p">{`script-shell`}</inlineCode>{` configuration.`}</p>
    <p>{`Scripts are run from the root of the package folder, regardless of what the
current working directory is when `}<inlineCode parentName="p">{`npm run`}</inlineCode>{` is called. If you want your
script to use different behavior based on what subdirectory you're in, you
can use the `}<inlineCode parentName="p">{`INIT_CWD`}</inlineCode>{` environment variable, which holds the full path you
were in when you ran `}<inlineCode parentName="p">{`npm run`}</inlineCode>{`.`}</p>
    <p><inlineCode parentName="p">{`npm run`}</inlineCode>{` sets the `}<inlineCode parentName="p">{`NODE`}</inlineCode>{` environment variable to the `}<inlineCode parentName="p">{`node`}</inlineCode>{` executable
with which `}<inlineCode parentName="p">{`npm`}</inlineCode>{` is executed.`}</p>
    <p>{`If you try to run a script without having a `}<inlineCode parentName="p">{`node_modules`}</inlineCode>{` directory and it
fails, you will be given a warning to run `}<inlineCode parentName="p">{`npm install`}</inlineCode>{`, just in case you've
forgotten.`}</p>
    <h3>{`Workspaces support`}</h3>
    <p>{`You may use the `}<inlineCode parentName="p">{`workspace`}</inlineCode>{` or `}<inlineCode parentName="p">{`workspaces`}</inlineCode>{` configs in order to run an
arbitrary command from a package's `}<inlineCode parentName="p">{`"scripts"`}</inlineCode>{` object in the context of the
specified workspaces. If no `}<inlineCode parentName="p">{`"command"`}</inlineCode>{` is provided, it will list the available
scripts for each of these configured workspaces.`}</p>
    <p>{`Given a project with configured workspaces, e.g:`}</p>
    <pre><code parentName="pre" {...{}}>{`.
+-- package.json
\`-- packages
   +-- a
   |   \`-- package.json
   +-- b
   |   \`-- package.json
   \`-- c
       \`-- package.json
`}</code></pre>
    <p>{`Assuming the workspace configuration is properly set up at the root level
`}<inlineCode parentName="p">{`package.json`}</inlineCode>{` file. e.g:`}</p>
    <pre><code parentName="pre" {...{}}>{`{
    "workspaces": [ "./packages/*" ]
}
`}</code></pre>
    <p>{`And that each of the configured workspaces has a configured `}<inlineCode parentName="p">{`test`}</inlineCode>{` script,
we can run tests in all of them using the `}<inlineCode parentName="p">{`workspaces`}</inlineCode>{` config:`}</p>
    <pre><code parentName="pre" {...{}}>{`npm test --workspaces
`}</code></pre>
    <h4>{`Filtering workspaces`}</h4>
    <p>{`It's also possible to run a script in a single workspace using the `}<inlineCode parentName="p">{`workspace`}</inlineCode>{`
config along with a name or directory path:`}</p>
    <pre><code parentName="pre" {...{}}>{`npm test --workspace=a
`}</code></pre>
    <p>{`The `}<inlineCode parentName="p">{`workspace`}</inlineCode>{` config can also be specified multiple times in order to run a
specific script in the context of multiple workspaces. When defining values for
the `}<inlineCode parentName="p">{`workspace`}</inlineCode>{` config in the command line, it also possible to use `}<inlineCode parentName="p">{`-w`}</inlineCode>{` as a
shorthand, e.g:`}</p>
    <pre><code parentName="pre" {...{}}>{`npm test -w a -w b
`}</code></pre>
    <p>{`This last command will run `}<inlineCode parentName="p">{`test`}</inlineCode>{` in both `}<inlineCode parentName="p">{`./packages/a`}</inlineCode>{` and `}<inlineCode parentName="p">{`./packages/b`}</inlineCode>{`
packages.`}</p>
    <h3>{`Configuration`}</h3>
    {
      /* AUTOGENERATED CONFIG DESCRIPTIONS START */
    }
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`workspace`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default:`}</li>
      <li parentName="ul">{`Type: String (can be set multiple times)`}</li>
    </ul>
    <p>{`Enable running a command in the context of the configured workspaces of the
current project while filtering by running only the workspaces defined by
this configuration option.`}</p>
    <p>{`Valid values for the `}<inlineCode parentName="p">{`workspace`}</inlineCode>{` config are either:`}</p>
    <ul>
      <li parentName="ul">{`Workspace names`}</li>
      <li parentName="ul">{`Path to a workspace directory`}</li>
      <li parentName="ul">{`Path to a parent workspace directory (will result in selecting all
workspaces within that folder)`}</li>
    </ul>
    <p>{`When set for the `}<inlineCode parentName="p">{`npm init`}</inlineCode>{` command, this may be set to the folder of a
workspace which does not yet exist, to create the folder and set it up as a
brand new workspace within the project.`}</p>
    <p>{`This value is not exported to the environment for child processes.`}</p>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`workspaces`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default: null`}</li>
      <li parentName="ul">{`Type: null or Boolean`}</li>
    </ul>
    <p>{`Set to true to run the command in the context of `}<strong parentName="p">{`all`}</strong>{` configured
workspaces.`}</p>
    <p>{`Explicitly setting this to false will cause commands like `}<inlineCode parentName="p">{`install`}</inlineCode>{` to
ignore workspaces altogether. When not set explicitly:`}</p>
    <ul>
      <li parentName="ul">{`Commands that operate on the `}<inlineCode parentName="li">{`node_modules`}</inlineCode>{` tree (install, update, etc.)
will link workspaces into the `}<inlineCode parentName="li">{`node_modules`}</inlineCode>{` folder. - Commands that do
other things (test, exec, publish, etc.) will operate on the root project,
`}<em parentName="li">{`unless`}</em>{` one or more workspaces are specified in the `}<inlineCode parentName="li">{`workspace`}</inlineCode>{` config.`}</li>
    </ul>
    <p>{`This value is not exported to the environment for child processes.`}</p>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`include-workspace-root`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default: false`}</li>
      <li parentName="ul">{`Type: Boolean`}</li>
    </ul>
    <p>{`Include the workspace root when workspaces are enabled for a command.`}</p>
    <p>{`When false, specifying individual workspaces via the `}<inlineCode parentName="p">{`workspace`}</inlineCode>{` config, or
all workspaces via the `}<inlineCode parentName="p">{`workspaces`}</inlineCode>{` flag, will cause npm to operate only on
the specified workspaces, and not on the root project.`}</p>
    <p>{`This value is not exported to the environment for child processes.`}</p>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`if-present`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default: false`}</li>
      <li parentName="ul">{`Type: Boolean`}</li>
    </ul>
    <p>{`If true, npm will not exit with an error code when `}<inlineCode parentName="p">{`run-script`}</inlineCode>{` is invoked
for a script that isn't defined in the `}<inlineCode parentName="p">{`scripts`}</inlineCode>{` section of `}<inlineCode parentName="p">{`package.json`}</inlineCode>{`.
This option can be used when it's desirable to optionally run a script when
it's present and fail if the script fails. This is useful, for example, when
running scripts that may only apply for some builds in an otherwise generic
CI setup.`}</p>
    <p>{`This value is not exported to the environment for child processes.`}</p>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`ignore-scripts`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default: false`}</li>
      <li parentName="ul">{`Type: Boolean`}</li>
    </ul>
    <p>{`If true, npm does not run scripts specified in package.json files.`}</p>
    <p>{`Note that commands explicitly intended to run a particular script, such as
`}<inlineCode parentName="p">{`npm start`}</inlineCode>{`, `}<inlineCode parentName="p">{`npm stop`}</inlineCode>{`, `}<inlineCode parentName="p">{`npm restart`}</inlineCode>{`, `}<inlineCode parentName="p">{`npm test`}</inlineCode>{`, and `}<inlineCode parentName="p">{`npm run-script`}</inlineCode>{`
will still run their intended script if `}<inlineCode parentName="p">{`ignore-scripts`}</inlineCode>{` is set, but they
will `}<em parentName="p">{`not`}</em>{` run any pre- or post-scripts.`}</p>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`foreground-scripts`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default: false`}</li>
      <li parentName="ul">{`Type: Boolean`}</li>
    </ul>
    <p>{`Run all build scripts (ie, `}<inlineCode parentName="p">{`preinstall`}</inlineCode>{`, `}<inlineCode parentName="p">{`install`}</inlineCode>{`, and `}<inlineCode parentName="p">{`postinstall`}</inlineCode>{`)
scripts for installed packages in the foreground process, sharing standard
input, output, and error with the main npm process.`}</p>
    <p>{`Note that this will generally make installs run slower, and be much noisier,
but can be useful for debugging.`}</p>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`script-shell`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default: '/bin/sh' on POSIX systems, 'cmd.exe' on Windows`}</li>
      <li parentName="ul">{`Type: null or String`}</li>
    </ul>
    <p>{`The shell to use for scripts run with the `}<inlineCode parentName="p">{`npm exec`}</inlineCode>{`, `}<inlineCode parentName="p">{`npm run`}</inlineCode>{` and `}<inlineCode parentName="p">{`npm
init <package-spec>`}</inlineCode>{` commands.`}</p>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    {
      /* AUTOGENERATED CONFIG DESCRIPTIONS END */
    }
    <h3>{`See Also`}</h3>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/using-npm/scripts"
        }}>{`npm scripts`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/commands/npm-test"
        }}>{`npm test`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/commands/npm-start"
        }}>{`npm start`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/commands/npm-restart"
        }}>{`npm restart`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/commands/npm-stop"
        }}>{`npm stop`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/commands/npm-config"
        }}>{`npm config`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/using-npm/workspaces"
        }}>{`npm workspaces`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      